import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { Auth } from '../../shared/services/auth';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';


@Component({
  selector: 'EmpTableResetPwd',
  templateUrl: 'resetPasswordByAdmin.html'
})
export class ResetPasswordPage {
  public localState: any;
  // public cp = 1;
  public _baseUrl: any;
  public employeeId: any;
  public showButtonLoading: any = false;
  public passwordToken: any = undefined;
  constructor(
    public route: ActivatedRoute,
    // public translate: TranslateService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public _global: Configuration,
    public _http: HttpClientCustom,
    public _auth: Auth,
    public _share: SharedData,
    public _toaster: ToasterComponent
  ) { this._baseUrl = _global.get("EPMS_BASE_URL"); }

  resetPassword() {
    try {
      let self = this;
      self.employeeId = self._share.getData();
      self.showButtonLoading = true;
      let url = self._baseUrl + "v1/webAdmin/employee/resetPassword/" + self.employeeId;
      self._http.get(url).subscribe((result) => {
        if (result.data) {
          self.translate.get('resetPasswordMailSent').subscribe((msg) => {
            self._toaster.showSuccess(msg);
          });
          setTimeout(() => { self.activeModal.close() }, 1000);
        } else {
          self.translate.get('failedWhileResettingPassword').subscribe((msg) => {
            self._toaster.showError(msg);
          });
          self.showButtonLoading = false;
        }
      });
    } catch (e) { console.log('Error in resetPassword', e); }
  }

  public notify(event) {
    this._toaster.showInfo("copied '" + event + "' To clipboard");
  }

  getPasswordToken() {
    try {
      let self = this;
      self.employeeId = self._share.getData();
      self.showButtonLoading = true;
      let url = self._baseUrl + "v1/webAdmin/employee/getResetPasswordToken/" + self.employeeId;
      self._http.get(url).subscribe((result) => {
        if (result.data) {
          self.passwordToken = result.data;
          self.showButtonLoading = false;
        } else {
          self._toaster.showError("Reset password token not found");
          self.showButtonLoading = false;
        }
      });
    } catch (e) { console.log('Error in resetPassword', e); }
  }

}



// WEBPACK FOOTER //
// ./src/app/employee/employeeActions/resetPasswordByAdmin.ts